import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { orders } from "../../../../../../redux/orders/action";
import { selectOrdersListItems, selectOrdersPrintItem } from "../../../../../../redux/orders/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { settings } from "../../../../../../redux/settings/actions";
import GetQuote from "../../../../../../models/GetQuote";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementOrders = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectOrdersListItems)
  const [pageSize, setPageSize] = useState(10);
  const orderInvoiceData = useSelector(selectOrdersPrintItem)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      }, {
        field: 'Message.InvoiceNumber', headerName: 'Invoice Number', searchField: 'InvoiceNumber', sortable: true, filter: true, filterType: 'text',
        isGeneratedPrintOrders: true
      },
      { field: 'Message.TrackingNumber', headerName: 'Eway Number', isGeneratedPDF: true },
      { field: 'Message.ShipmentPId', headerName: 'Order Id' },
      { field: 'Message.CustomerName', headerName: 'Customer Name', },
      { field: 'Message.TransporterName', headerName: 'Transporter Name' },
      { field: 'Message.AgentName', headerName: 'Agent Name' },
      { field: 'Message.TrackingNumber', headerName: 'Tracking Number', sortable: false, filter: true },

      {
        field: 'Message.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      { field: 'Message.CreatedOnUtc', headerName: 'Order Date', isDateValueFormat: true, },
      { field: 'Message.DeliveryDateUtc', headerName: 'Delivery Date', isDateValueFormat: true, },
    ]);
  }

  const fetchOrders = () => {
    dispatch(settings.set({ getQuote: 'close' }))
    dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchOrders()
  }, [pageData, pageSize])

  const handleAdd = () => {
    dispatch(settings.set({ getQuote: 'open' }))
  }

  const handleDelete = (data: any) => {
    dispatch(orders.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/delete`,
      entity: 'orders',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Message?.Id
            }

          }
        ]
      }
    })).then(() => {
      fetchOrders()
    });
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const handleReloadData = () => {
    fetchOrders()
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Orders</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Message.InvoiceNumber",
        FieldText: "Message.InvoiceNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`,
      entity: 'order',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }


  const launchPrintInvoice = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      window.open(
        `${window.location.origin}/order/invoice/${data?.Message?.InvoiceNumber}`,
        '_blank',
        windowProps
      );
    }
  }
  const handleGeneratePrintOrdersInvoice = async (data: any) => {

    launchPrintInvoice(data);
  }
  const launchPdfInBrowser = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      window.open(
        `${window.location.origin}/order/e-way/${data?.Message?.TrackingNumber}`,
        '_blank',
        windowProps
      );
    }
  }

  const handleGeneratePrintEWayBill = async (data: any) => {

    launchPdfInBrowser(data);
  }
  return (
    <>
      <GetQuote />

      {itemsData?.isLoading ? <PageLoader />
        :
        <Table columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onGeneratePdfInvoice={handleGeneratePrintEWayBill}
          onGeneratePrintOrderInvoice={handleGeneratePrintOrdersInvoice}
          onSearch={handleSearch}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          onDelete={handleDelete}
          headingName="Orders" />
      }
    </>

  );
};

export default ManagementOrders;


